/* Updated and polished portfolio configuration file */

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/wolfloading";

// Splash Screen
const splashScreen = {
  enabled: true,
  animation: splashAnimation,
  duration: 1500
};

// Summary and Greeting Section
const illustration = {
  animated: false
};

const greeting = {
  username: "ggrigoriadis",
  title: "Hi! I'm George",
  subTitle: emoji("I’m 22 based in Athens, Greece, specializing in multiplayer systems and online game experiences."),
  resumeLink: "https://drive.google.com/uc?export=download&id=17JJ0nQtBy1o_7dRCv6VcZ8xxctrtBnT1",
  displayGreeting: true
};

// Social Media Links
const socialMediaLinks = {
  github: "https://github.com/giorgosgrigoriadis",
  linkedin: "https://www.linkedin.com/in/georgios-grigoriadis-26064a200/",
  gmail: "giorgosgrigoriadis9@gmail.com",
  itchio: "https://ntiregoylfios.itch.io/",
  display: true
};

// Skills Section
const skillsSection = {
  title: "",
  subTitle: (
    <>
      
      <br />
      
    </>
  ),
  skills: [
    emoji("⚡ I'm always looking for opportunities to learn and grow as a game developer."),
    emoji("⚡ Passionate about designing seamless multiplayer interactions and solving networking challenges.")
  ],
  softwareSkills: [
    { skillName: "Unity", fontAwesomeClassname: "fas fa-cube" },
    { skillName: "Unreal Engine", fontAwesomeClassname: "fas fa-gamepad" },
    { skillName: "C#", fontAwesomeClassname: "fas fa-code" },
    { skillName: "Photon", fontAwesomeClassname: "fas fa-bolt" },
    { skillName: "Mirror", fontAwesomeClassname: "fas fa-network-wired" },
    { skillName: "Git", fontAwesomeClassname: "fab fa-git-alt" },
    { skillName: "GitHub", fontAwesomeClassname: "fab fa-github" },
    { skillName: "Reactjs", fontAwesomeClassname: "fab fa-react" },
  ],
  display: true
};

// Education Section
const educationInfo = {
  display: true,
  schools: [
    {
      schoolName: "SAE Institute Athens",
      logo: require("./assets/images/saeLogo.png"),
      subHeader: "BSc in Games Programming",
      duration: "October 2022 – Present",
      desc: "Focused on game development with courses in gameplay programming, engine architecture, and multiplayer networking.",
      descBullets: []
    }
  ]
};

// Tech Stack Experience
const techStack = {
  viewSkillBars: false,
  experience: [
    { Stack: "Unity", progressPercentage: "0%" },
    { Stack: "Backend", progressPercentage: "70%" },
    { Stack: "Programming", progressPercentage: "60%" }
  ],
  displayCodersrank: true
};

// Work Experience Section
const workExperiences = {
  display: true,
  experience: [
    {
      role: "Instructor",
      company: "IEK Intergraphics",
      companylogo: require("./assets/images/iekintergraphicslogo.png"),
      date: "Oct 2024 – Present",
      desc: "",
      descBullets: [
        "Giving lectures on the Unity 3D game engine and game development topics",
        "Mentoring students in troubleshooting their game development projects."
      ]
    },
    {
      role: "Customer Support & QA Lead",
      company: "Admate Hellas",
      companylogo: require("./assets/images/admatelogo1.png"),
      date: "Feb 2024 – Dec 2024",
      desc: "",
      descBullets: [
        "Managed 200+ clients across Greece.",
        "Trained and mentored a junior team member from no experience to independently handling their assigned position."
      ]
    },
    {
      role: "Network System Consultant",
      company: "Purple Cow Studios",
      companylogo: require("./assets/images/purplecowlogo.png"),
      date: "Jun 2019 – Aug 2019",
      desc: "",
      descBullets: [
        "Assisted in reviewing and advising on multiplayer networking approaches.",
        "Collaborated with developers to debug and enhance network performance and scalability."
      ]
    }
  ]
};

// Open Source Section
const openSource = {
  showGithubProfile: "true",
  display: true
};

// Project Portfolio Section  // FILE => STARTUP PROJECTS
const bigProjects = {
  title: "Projects",
  subtitle: "",
  projects: [
    {
      image: require("./assets/images/HoverLasersLogo.png"),
      projectName: "Hover Lasers",
      projectDesc: "High-speed, high-stakes multiplayer racing game for up to 8 players.",
      footerLink: [
        { name: "Itch.io", url: "https://ntiregoylfios.itch.io/hover-lasers" }
        //{ name: "Steam", url: "https://ntiregoylfios.itch.io/hover-lasers" }
      ],
      techTags: ["Unity", "Photon", "In-Development"]
    },
    {
      image: require("./assets/images/rumramlogo.png"),
      projectName: "Rum Ram",
      projectDesc: "A fast-paced multiplayer brawler for up to 4 players focused on chaotic, physics-driven combat.",
      footerLink: [
        { name: "Steam", url: "https://store.steampowered.com/app/819940/Rum_Ram/" }
        //{ name: "Steam", url: "https://ntiregoylfios.itch.io/hover-lasers" }
      ],
      techTags: ["Unreal", "Unreal Networking", "Released", "Purple Cow Studios"]
    },
    {
      image: require("./assets/images/EternalDungeonlogo.png"),
      projectName: "Eternal Dungeons",
      projectDesc: "3v3 dungeon race game with character selection and multiplayer competition.",
      footerLink: [
        { name: "Itch.io", url: "https://ntiregoylfios.itch.io/eternal-dungeon" }
      ],
      techTags: ["Unity", "Photon", "Prototype"]
    },
    {
      image: require("./assets/images/EternalDungeonsVRlogo.png"),
      projectName: "Eternal Dungeons VR",
      projectDesc: "Single-player VR arena shooter with bow-based combat against waves of undead.",
      footerLink: [
        { name: "Itch.io", url: "https://ntiregoylfios.itch.io/eternal-dungeons-vr" }
      ],
      techTags: ["Unity", "Canceled"]
    }
  ],
  display: true
};

// Project Portfolio Section
const jamProjects = {
  title: "GameJams 🏆",
  subtitle: "",
  projects: [
    {
      image: require("./assets/images/paintover_logo.png"),
      projectName: "Paint Over",
      projectDesc: "Paint Over is a chaotic single-player bullet mayhem game where paint is your power and survival is your goal.",
      footerLink: [
        { name: "Itch.io", url: "https://ntiregoylfios.itch.io/paint-over" }
      ],
      techTags: ["Unity", "Mini Jame Gam #43"]
    },
    {
      image: require("./assets/images/crackariologo.png"),
      projectName: "Crackario",
      projectDesc: "Chaotic 2D platformer full of meme madness and off-brand heroics.",
      footerLink: [
        { name: "Itch.io", url: "https://ntiregoylfios.itch.io/crackario" }
      ],
      techTags: ["Unity", "Global Game Jam 2024"]
    },
    {
      image: require("./assets/images/theescapechapterlogo.png"),
      projectName: "TheEscapeChapter",
      projectDesc: "Chill story-driven puzzle game with light magic, mysterious vibes, and... a very strange chest.",
      footerLink: [
        { name: "Itch.io", url: "https://ntiregoylfios.itch.io/dreamscape" }
      ],
      techTags: ["Unity", "GameJamPlus 24/25"]
    },
    {
      image: require("./assets/images/plantsvswizardslogo.png"),
      projectName: "Plants Vs Wizards",
      projectDesc: "Local co-op tower defense game where two wizards protect golden trees.",
      footerLink: [
        { name: "Itch.io", url: "https://ntiregoylfios.itch.io/plants-vs-wizards" }
      ],
      techTags: ["Unity", "Global Game Jam 2023"]
    },
  ],
  display: true
};

// Game Jam Achievements Section
const achievementSection = {
  title: emoji("GameJams 🏆 "),
  subtitle: "",
  achievementsCards: [
    {
      title: "Plants Vs Wizards",
      subtitle: "Local co-op tower defense game where two wizards protect golden trees.",
      image: require("./assets/images/plantsvswizardslogo.png"),
      footerLink: [
        { name: "Itch.io", url: "https://ntiregoylfios.itch.io/plants-vs-wizards" }
      ],
      techTags: ["Unity", "Global Game Jam 2023"]
    }
  ],
  display: false
};

// Blogs Section
const blogSection = {
  title: "Blogs",
  subtitle: "With love for developing cool stuff, I enjoy teaching others what I've learned.",
  displayMediumBlogs: "true",
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description: "Create a Google Assistant Action in less than 30 minutes and win rewards."
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description: "React is a JavaScript library for building user interfaces."
    }
  ],
  display: false
};

// Talks Section
const talkSection = {
  title: "TALKS",
  subtitle: emoji("I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"),
  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false
};

// Podcast Section
const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",
  display: true
};

// Contact Section
const contactInfo = {
  title: emoji("Contact Me"),
  subtitle: "Discuss a project or just want to say hi? My inbox is open to all.",
  number: "",
  email_address: "giorgosgrigoriadis9@gmail.com"
};

// Twitter Section
const twitterDetails = {
  userName: "ggrigoriadis",
  display: false
};

// Open For GameJams
const isHireable = true;

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  jamProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};